// src/components/Pagination.tsx
import React from "react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <div className="flex justify-end items-center gap-2 p-4 mt-6 bg-gray-100 sticky bottom-0">
      {pages.map((p) => (
        <button
          key={p}
          onClick={() => onPageChange(p)}
          className={`px-3 py-2 rounded-md text-sm font-medium transition-all duration-200
            ${
              p === currentPage
                ? "bg-gray-700 text-white scale-105"
                : "bg-black text-white hover:bg-gray-800 hover:-translate-y-0.5"
            }`}
        >
          {p}
        </button>
      ))}
    </div>
  );
};

export default Pagination;
